import FormattedMessage from 'I18n/components/FormattedMessage';
import ResponsiveCardGridContainer from '../ResponsiveCardGridContainer';
import ContentCardSkeleton from '../TrackCard/ContentCardSkeleton';
import ApiError from '../Errors/ApiError';
import { SkeletonBlock } from '../Skeleton';
import styled from 'styled-components';
import { device } from '../../constants/StyledComponentConstants';
import SectionHeading from '../SectionHeading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendationsSkeletonWrapper = styled.div.withConfig({
  displayName: "RecommendationsSkeleton__RecommendationsSkeletonWrapper",
  componentId: "sc-1wsekov-0"
})(["margin-top:35px;@media screen and ", "{margin-top:20px;}"], device.mobile);
const RecommendationsSkeleton = ({
  error
}) => {
  return /*#__PURE__*/_jsxs(RecommendationsSkeletonWrapper, {
    "data-test-id": "recommendations-skeleton",
    children: [/*#__PURE__*/_jsx(SectionHeading, {
      subText: /*#__PURE__*/_jsx(SkeletonBlock, {
        style: {
          height: 16,
          width: '30%',
          marginTop: 6
        }
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.headers.recommended"
      })
    }), error ? /*#__PURE__*/_jsx(ApiError, {
      error: error
    }) : /*#__PURE__*/_jsxs(ResponsiveCardGridContainer, {
      columnSize: 250,
      columns: 3,
      maxCardWidth: 405,
      nowrap: true,
      children: [/*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {})]
    })]
  });
};
export default RecommendationsSkeleton;